export default "__VITE_PUBLIC_ASSET__7eeb36c5__"